
import ArrowSVG from '@/assets/svg/arrow-left.svg?inline'

export default {
  name: 'Pagination',

  components: {
    ArrowSVG,
  },

  props: {
    pages: {
      type: Object,
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      activePage: 1,
      max: 10,
      min: 1,
    }
  },

  watch: {
    pages: {
      deep: true,
      handler() {
        this.activePage = this.pages.cursor
      },
    },
  },

  methods: {
    pageChanged(page) {
      this.$emit('pageChanged', page)
      this.activePage = page
    },
  },
}
